<template>
  <!-- <div class="">
    <PageHeader> </PageHeader> -->

  <div class="main layout-main">
    <div class="left">
      <div class="nav-left-title">
        <span class="icon-left">
          <!-- <img src="@/assets/images/icons/hangye.png" class="img" /> -->
          <img :src="$route.meta.icon" class="img" />
        </span>
        <span class="tit"> 行业概况 </span>
      </div>
      <div class="nav-left-items" id="navLeft">
        <div
          class="nav-left-item"
          :class="{ active: i === curIndex }"
          v-for="(item, i) in list"
          :key="item.Id"
          :data-id="item.id"
          @mouseover="navLeftItemMouseover(i, $event)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="right">
      <template v-if="list[curIndex]">
        <div class="nav-right-title">
          <div class="tit">
            {{ list[curIndex].title }}
          </div>
        </div>
        <!-- <router-view></router-view> -->
        <Content :content="list[curIndex].content"></Content>
      </template>
    </div>
  </div>
  <!-- <PageFooter> </PageFooter>
    <FixedLeft> </FixedLeft>
    <FixedRight> </FixedRight>
  </div> -->
</template>

<script>
// import { routesNav } from "@/router/index";
import { getHangYeGaiKuang } from "@/apis/api";
import Content from "./components/Content.vue";

export default {
  name: "hangye",
  components: {
    Content,
  },
  data() {
    return {
      curIndex: 0,
      list: [],
    };
  },
  created() {
    console.log(this.$router);
    console.log(this.$route);
    this.getHangYeGaiKuang();
  },
  methods: {
    navLeftItemMouseover(i, e) {
      // if (this.$route.name === "lianzheng") {}
      this.scrollToTop();
      // setTimeout(() => {
      this.curIndex = i;
      // }, 50);
      e.stopPropagation();
      e.preventDefault;
    },
    async getHangYeGaiKuang() {
      const { data } = await getHangYeGaiKuang();
      this.list = data || [];
    },
  },
  computed: {
    // prevRoute() {
    //   // const matched = this.$route.matched;
    //   // const len = matched.length;
    //   return routesNav.find((v) => {
    //     // return v.name === matched[len - 2].name;
    //     return v.name === "hangye";
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/nav-layout.scss";
.right {
  min-height: 900px !important;
}
</style>
